<template>
  <div
    class="container min-body-height"
    :class="UI.isMobile ? '' : 'padding-top'"
  >
    <div
      class="flex align-center justify-between"
      :class="UI.isMobile ? 'flex-direction' : ''"
    >
      <h1>成绩列表</h1>

      <el-form
        :inline="!UI.isMobile"
        :label-position="UI.isMobile ? 'top' : 'right'"
        size="mini"
        :model="filterForm"
      >
        <el-form-item label="项目">
          <el-select v-model="filterForm.item">
            <el-option
              :value="item.value"
              :label="item.label"
              v-for="(item, key) in itemsOptions"
              :key="key"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="组别">
          <el-select v-model="filterForm.group">
            <el-option
              :value="item.value"
              :label="item.label"
              v-for="(item, key) in groupsOptions"
              :key="key"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="
              page = 1;
              flushData();
            "
          >
            查询
          </el-button>
          <el-button
            @click="
              filterForm = { page: 1, page_size: 10 };
              flushData();
            "
          >
            重置
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="full-width margin-bottom bg-grey" style="height: 1px;"></div>

    <el-table
      class="margin-top"
      :data="tableData"
      style="width: 100%"
      header-row-class-name="bg-default"
      :row-class-name="tableRowClassName"
      @cell-click="cellClick"
    >
      <el-table-column prop="sort" label="名次" sortable>
        <template slot-scope="scope">
          {{
            parseFloat(scope.row.sort).toString() == 'NaN'
              ? scope.row.sort
              : Number(scope.row.sort)
          }}
        </template>
      </el-table-column>

      <el-table-column prop="num" label="参赛号" sortable></el-table-column>
      <el-table-column label="姓名">
        <template slot-scope="scope">
          {{ scope.row.user_info.name }}
        </template>
      </el-table-column>

      <el-table-column prop="group" label="组别" sortable></el-table-column>
      <el-table-column prop="org" label="单位" sortable></el-table-column>
      <el-table-column prop="result" label="成绩" sortable></el-table-column>
      <el-table-column
        prop="time_difference"
        label="时差"
        sortable
      ></el-table-column>
    </el-table>

    <div class="flex justify-center align-center full-width margin-top">
      <el-pagination
        :hide-on-single-page="total <= filterForm.page_size"
        @current-change="handleCurrentChange"
        :current-page.sync="filterForm.page"
        :page-size="filterForm.page_size"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { getGameById, getGameResult } from '@/servers/games.js';
import { mapState } from 'vuex';
import { wxShareMixins } from '@/mixins/wx_share.js';

export default {
  mixins: [wxShareMixins],
  data() {
    return {
      filterForm: {
        page: 1,
        page_size: 1000,
      },
      total: 0,
      tableData: [],
      groupsOptions: [],
      itemsOptions: [],
    };
  },

  computed: {
    ...mapState(['UI']),
  },

  watch: {
    $route: 'routeChange',
  },

  created() {
    this.routeChange();
  },

  methods: {
    routeChange: function() {
      let that = this;
      getGameById(this.$route.query.id, {}, function(res) {
        that.groupsOptions = [];
        res.groups.forEach((item) => {
          that.groupsOptions.push({
            label: item,
            value: item,
          });
        });
        that.$set(that.filterForm, 'group', res.groups[0]);

        that.itemsOptions = [];
        res.items.forEach((item) => {
          that.itemsOptions.push({
            label: item.title,
            value: item.id,
          });
        });
        if (res.items && res.items.length) {
          that.$set(that.filterForm, 'item', res.items[0].id);
        }
        that.flushData();
      });
    },

    flushData: function() {
      let that = this;
      this.page = 1;
      getGameResult(this.filterForm, function(res) {
        that.tableData = res.items.filter((item) => {
          return item.sort > 0;
        });
        that.total = res.total;
      });
    },

    handleCurrentChange: function() {
      this.flushData();
    },

    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return 'bg-gray cursor-pointer';
      } else {
        return 'bg-white cursor-pointer';
      }
    },

    cellClick: function(row, column, cell, event) {
      this.$router.push({
        name: 'playerInfo',
        query: { id: row.user_id },
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/index/games/results.vue